<script>

import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue';

export default {
    extends: CoreComponent,
    data() {
        return {
            path: null, 
            activeTopic: 'all',
            jsonResponse: null,
            articlesHTML: '',
            limit: 6,
            offset: 0,
            endOfTopic: false,
            loadButton: null,
            searchButton: null,
            searchInput: null,
            searchClear: null,
            filters: null
        };
    },
    methods: {
        fetchPath() {
           if(document.querySelectorAll(".cmp-article-filter").length > 0) {
            let el = document.querySelector(".cmp-article-filter");
                        
            if(this.path === null) {
                this.path = el.dataset.rootPath; 
            }
            
           }
           
        },

        search() {
            let search = this.searchInput.value;
            if (search) {
                search = search.substring(0,100).replace(/^[*%?]+/, '');
                search = encodeURIComponent(search);
                this.fetchArticles(false, search)
            } else {
                this.fetchArticles()
            }
        },

        clearSearch() {
            this.searchInput.value = "";
            this.fetchArticles();
        },

        updateTagCounts(tagCounts, search) {
            this.filters.forEach(filter => {
                let span = filter.querySelector("span");
                if (search) {
                    let tagName = filter.dataset.name;
                    span.innerText = tagCounts[tagName] || 0;
                } else {
                    span.innerText = filter.dataset.total;
                }
                
            }); 
        },

        async fetchArticles(append = false, search = null) {

            this.fetchPath();
            
            let articleWrapper = document.querySelector('.cmp-article-filter__grid');

            if (this.cmpEl.classList.contains("cmp-article-filter--short-layout")) {
                this.limit = 3;
            } 

            if (search) { //use search styles
                articleWrapper.classList.add("cmp-article-filter__grid--search");
            } else { //use standard styles
                articleWrapper.classList.remove("cmp-article-filter__grid--search");
            }

            if (!append) { articleWrapper.innerHTML = ''; }
            try {

                // Limit + 1 to check if more articles exist
                let path = `.dow.article.filter.json?articlesPath=${this.path}&limit=${search ? -1 : this.limit + 1}&offset=${this.offset}&topic=${this.activeTopic}`;
                if (search) { path += `&search=${search}`;}
                let response = await fetch(
                    path,
                    {
                        mode: 'no-cors',
                        method: 'GET',
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                this.jsonResponse = await response.json();

                let articles = this.jsonResponse.articles || [];
                let tagCounts = this.jsonResponse.tagCounts || {};
                tagCounts["All"] = articles.length || 0;

                this.updateTagCounts(tagCounts, search);

                if (search && (articles.length == 0 || !articles)) {
                    articleWrapper.innerHTML = "<p class='cmp-article-filter__no-results'>No results found.</p>"
                } else {
                    // Set render limit based on render type
                    let limit = search ? articles.length : Math.min(articles.length, this.limit);
                    for (let i=0; i<limit; i++) {
                        let article = articles[i];
                        
                        let link = document.createElement("a");
                        link.classList.add("article-filter-tile__link");
                        link.href = article.link;
                        link.setAttribute("aria-label", "Read " + article.heading);

                        if (search) { // render search layout
                            link.innerHTML = `<div class="article-filter-tile__tile">
                                <div class="article-filter-tile__image" style="background-image:url('${article.thumbnailImage}')">
                                <img src="${article.thumbnailImage}" alt="${article.articleAltText}">
                                </div>	 
                        
                                <div class="article-filter-tile__content">
                                <h3 class="content__title">${article.heading}</h3>
                                <p class="content__detail">${article.summary}</p>
                                <p class="content__label"><span class="label__date">${article.articleDate}</span> | <span class="label__name">${article.author}</span> | ${article.tags[0]}</p>

                                </div>
                            </div>`;
                        } else { // render standard layout
                            link.innerHTML = `<div class="article-filter-tile__tile">
                                <div class="article-filter-tile__image" style="background-image:url('${article.thumbnailImage}')">
                                <img src="${article.thumbnailImage}" alt="${article.articleAltText}">
                                </div>	 
                        
                                <div class="article-filter-tile__content">
                                <p class="content__label"><span class="label__name">${article.author}</span> | ${article.tags[0]}</p>
                                <h3 class="content__title">${article.heading}</h3>
                                <p class="content__detail">${article.summary}</p>
                                <p class="content__date">${article.articleDate}</p>
                                </div>
                            </div>`;
                        }

                        articleWrapper.appendChild(link);

                    }
                }

                console.log(search);
                if (articles.length <= this.limit || search) {
                    console.log("hide load");
                    this.hideLoadButton();
                } else {
                    console.log("show load");
                    this.showLoadButton();
                }


            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        changeTab(tabId) {
            this.activeTopic = tabId;
            this.offset = 0; 
            this.showLoadButton();
            // change tab with search if search entered
            if (this.searchInput && this.searchInput.value.trim() != "") {
                this.search();
            } else {
                this.fetchArticles();
            }
        },
        loadMore() {
            this.offset += this.limit;
            this.fetchArticles(true);
            
        },
        hideLoadButton() {
            this.loadButton.style.display = "none";
        },
        showLoadButton() {
            this.loadButton.style.removeProperty("display");
        }
    },
    mounted() {
        let urlParams = new URLSearchParams(window.location.search);

        this.limit = this.cmpEl.dataset.articleLimit || this.limit;

        this.filters = document.querySelectorAll(".cmp-article-filter__filter");

        this.filters.forEach(filter => {

            filter.addEventListener("click", e => {

                let active = document.querySelector('.cmp-article-filter__filter--active');
                if (active) {
                    active.classList.remove('cmp-article-filter__filter--active');
                }

                this.changeTab(filter.dataset.id);
                filter.classList.add('cmp-article-filter__filter--active');
                
                urlParams.set("topic", filter.dataset.id);
                history.pushState(null, null, "?"+urlParams.toString());

            });
        });
         
        // Mobile Dropdown Menu
        document.querySelector("#blog-mobile-dropdown").addEventListener("change", e => {
            this.changeTab(e.target.value);          
            urlParams.set("topic", e.target.value);                
            history.pushState(null, null, "?"+urlParams.toString());
        });

        this.searchInput = this.cmpEl.querySelector(".cmp-article-filter__search-input");
        this.searchInput?.addEventListener("keyup", e => {
            if (e.key == "Enter") { this.search() };
        })

        this.searchButton = this.cmpEl.querySelector(".cmp-article-filter__search-button");
        this.searchButton?.addEventListener("click", e => {
            this.search();
        });

        this.searchClear = this.cmpEl.querySelector(".cmp-article-filter__search-clear");
        this.searchClear?.addEventListener("click", e => {
            this.clearSearch();
        })

        this.loadButton = document.querySelector(".cmp-article-filter__load-button");
        this.loadButton.addEventListener("click", e => {
            this.loadMore();
            e.preventDefault();
        })

        // Check URL if 'topic' was selected
        if(urlParams.has('topic')) {
            let topic = decodeURIComponent(urlParams.get('topic'));
            this.activeTopic = topic;
        } 

        document.querySelector('button.cmp-article-filter__filter[data-id="'+this.activeTopic+'"]').classList.add('cmp-article-filter__filter--active');
        document.querySelector('#blog-mobile-dropdown').value = this.activeTopic;
        
        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                this.fetchPath();
                this.fetchArticles();
            }
        }

    }
};

</script>

<style lang="scss">
    @import './articleFilter.scss';
</style>
